type CheckPermission = (resourceId: string, resourceType: string) => boolean;

/**
 * Whether a person meets the RBAC pre-reqs for Home: All Documents access
 * (`documents` view) and Ask AI (`conversational_ai` edit). Document
 * Dashboards access alone does not count.
 */
export function meetsHomePrereqs({
  isSuperAdmin,
  checkPermission,
}: {
  isSuperAdmin: boolean;
  checkPermission: CheckPermission;
}) {
  if (isSuperAdmin) return true;

  return (
    checkPermission('documents', 'view') &&
    checkPermission('conversational_ai', 'edit')
  );
}
